var _path, _path2, _path3, _path4, _path5, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdenredLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 44,
    viewBox: "0 0 74 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4259_13330)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7514 19.1172C26.4483 19.1172 25.6191 19.9001 25.3626 20.9379H30.0021C29.8442 19.791 28.9755 19.1172 27.7514 19.1172Z",
    fill: "#5F6161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6813 22.4454C12.6813 24.0116 13.7705 25.1862 15.4448 25.1862C17.1192 25.1862 18.2487 24.0705 18.2487 22.4454C18.2487 20.8205 17.1192 19.7241 15.4448 19.7241C13.7503 19.7241 12.6813 20.8596 12.6813 22.4454Z",
    fill: "#5F6161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8036 25.3119C29.6925 25.3119 30.516 25.0607 31.2866 24.7125L31.0356 27.0519C30.1666 27.3998 29.1196 27.5354 28.0729 27.5354C24.5964 27.5354 22.1472 25.544 22.1472 22.1606C22.1472 19.2222 24.3398 17.018 27.6974 17.018C31.4899 17.018 33.3862 19.3765 33.3071 23.0114H25.4854C25.7817 24.6739 27.4013 25.3119 28.8036 25.3119ZM21.18 21.6772C21.18 25.37 18.948 27.5354 15.2543 27.5354C11.8373 27.5354 9.52637 25.2926 9.52637 22.2766C9.52637 19.1253 11.7187 17.018 14.9975 17.018C16.4988 17.018 17.6047 17.5979 18.1579 18.1782V13.6929H21.18V21.6772ZM44.1395 20.5209C44.1164 20.5222 44.155 20.52 44.1316 20.5213C43.3485 9.06057 34.1105 0 22.2048 0C12.7952 0 4.74063 5.66158 1.39136 13.6929H9.36858L8.95392 16.3219H2.6927V19.106H8.36128L7.92689 21.6386H2.6927V23.2628C2.6927 24.2485 3.12709 24.7125 3.95664 24.7125H9.30941L8.87502 27.3419H2.94935C2.66051 27.3419 2.38618 27.316 2.12523 27.2696V27.2718C2.12523 27.2718 1.09889 27.1622 0.464087 26.3538C0.448444 26.3351 0.189761 26.0342 0.0623469 25.5389C0.0292463 25.4095 0.0269792 25.4009 0 25.3008C0.0421691 25.6281 0.113811 26.0673 0.145778 26.2308C0.325791 27.1475 0.555 27.924 0.575405 27.979C3.23728 37.2224 11.9096 44 22.2048 44C32.7357 44 41.6316 36.9104 44.0706 27.3419H41.0496V21.9675C41.0496 20.5175 40.4765 19.5893 39.0151 19.5893C37.5532 19.5893 36.9805 20.5175 36.9805 21.9675V27.3419H33.9586V21.2325C33.9586 18.3133 36.131 17.018 39.0151 17.018C41.8989 17.018 44.0715 18.3133 44.0715 21.2325L44.0706 27.3419H47.1109V21.9675C47.1109 20.5175 47.506 19.5893 48.9477 19.5893C49.4021 19.5893 49.9552 19.7244 50.1525 19.8214L50.7252 17.2306C50.3896 17.192 49.5404 17.018 48.8886 17.018C46.3972 17.018 44.4563 17.9926 44.1395 20.5209Z",
    fill: "#5F6161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6669 21.054C53.9232 19.9412 54.7507 19.1017 56.0509 19.1017C57.2726 19.1017 58.1394 19.8242 58.2971 21.054H53.6669ZM55.9525 16.9932C52.6028 16.9932 50.4159 19.2189 50.4159 22.1864C50.4159 25.603 52.8591 27.6139 56.327 27.6139C57.3712 27.6139 58.4156 27.4774 59.2824 27.126L59.5324 24.7638C58.7641 25.1149 57.9425 25.3688 57.0559 25.3688C55.6569 25.3688 54.0412 24.7246 53.7456 23.0454H61.5483C61.627 19.3751 59.7357 16.9932 55.9525 16.9932Z",
    fill: "#5F6161"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4259_13330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 13,
    width: 13,
    height: 15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8799 13.749H73.4981V27.5701H61.8799V13.749Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4259_13330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7283 25.0221C66.0939 25.0221 65.0307 23.8639 65.0307 22.3198C65.0307 20.756 66.0743 19.6365 67.7283 19.6365C69.3627 19.6365 70.4655 20.7175 70.4655 22.3198C70.4655 23.9218 69.3627 25.0221 67.7283 25.0221ZM70.4852 13.749V18.2273C69.9339 17.6486 68.8311 17.0692 67.3346 17.0692C64.0658 17.0692 61.8799 19.1734 61.8799 22.3198C61.8799 25.3311 64.1838 27.5701 67.5907 27.5701C71.2729 27.5701 73.4981 25.4082 73.4981 21.7216V13.749H70.4852Z",
    fill: "#5F6161"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4259_13330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 44,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdenredLogo);
export default __webpack_public_path__ + "static/media/EdenredLogo.685a94a893f749b7fb5ae7390107ea48.svg";
export { ForwardRef as ReactComponent };